export default "__VITE_ASSET__a8a28c6c__"